export default function PageShell({ title, children }) {
    return (
        <div className="crm-app-shell">

            <div className="crm-main">
                <div className="crm-page-body">{children}</div>
            </div>
        </div>
    );
}